export interface SigoStatus {
    id: number;
    label: string;
    value: number;
  }
  
  export const STATUS_SIGO_LIST: SigoStatus[] = [
    { id: 1, label: "Pendente", value: 1 },
    { id: 2, label: "Cancelado", value: 2 },
    { id: 3, label: "Aguardando Pagamento", value: 3 },
    { id: 4, label: "Devolvido", value: 4 },
    { id: 5, label: "Aguardando Auditoria Médica", value: 5 },
    { id: 6, label: "Aguardando Confirmação do Cliente", value: 6 },
    { id: 7, label: "Orçamento Validado", value: 7 },
    { id: 8, label: "Autorizado", value: 8 },
    { id: 9, label: "Processado", value: 9 },
    { id: 10, label: "Validado e Ausente de Crítica", value: 10 },
    { id: 11, label: "Em digitação pela Concessionária", value: 11 },
    { id: 12, label: "Assinado pelo Cliente", value: 12 },
    { id: 13, label: "Orçamento Recusado pelo Cliente", value: 13 },
    { id: 14, label: "Cancelado p/Falta de Pagamento (07 dias)", value: 14 },
    { id: 15, label: "Cancelado p/Decurso de Prazo (25 dias)", value: 15 },
    { id: 16, label: "Cancelamento p/Divergência na D.S", value: 16 },
    { id: 17, label: "Valido com dados divergentes", value: 17 },
    { id: 18, label: "Pago pelo cliente", value: 18 },
    { id: 19, label: "Pago ao vendedor", value: 19 },
    { id: 20, label: "Pendencia medica", value: 20 },
  ];